// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1usA3","right":"styles_right__2yIHj"};